import React from "react";
import { FormattedMessage } from "react-intl";

export interface ColumnDescription {
  id: string;
  columnNameCandidates: Array<string>;
  description: React.ReactNode;
  hasAsterisk?: boolean;
}

export function getDefaultColumnName(
  columnDescription: ColumnDescription
): string {
  const baseName = columnDescription.columnNameCandidates[0];
  return columnDescription.hasAsterisk ? `${baseName}*` : baseName;
}

export const productIdColumnDescription: ColumnDescription = {
  id: "productId",
  columnNameCandidates: ["Product ID", "Recipe ID", "ID"],
  hasAsterisk: true,
  description: (
    <FormattedMessage
      id="components/sales-data/sales-data-csv-columns:productIdColumnDescription"
      defaultMessage="Foodsteps unique identifier."
    />
  ),
};

export const productCodeColumnDescription: ColumnDescription = {
  id: "productCode",
  columnNameCandidates: ["Product code", "Recipe Code", "PLU", "Code", "SKU"],
  hasAsterisk: true,
  description: (
    <FormattedMessage
      id="components/sales-data/sales-data-csv-columns:productCodeColumnDescription"
      defaultMessage="Unique identifier in your own database (must be an existing product in Foodsteps)."
    />
  ),
};

export const productNameColumnDescription: ColumnDescription = {
  id: "productName",
  columnNameCandidates: ["Product Name", "Recipe Name", "Name"],
  description: (
    <FormattedMessage
      id="components/sales-data/sales-data-csv-columns:productNameColumnDescription"
      defaultMessage="The name of the product. <em>(Optional)</em>"
      values={{
        em: (chunks: React.ReactNode) => <em>{chunks}</em>,
      }}
    />
  ),
};

export const quantitySoldColumnDescription: ColumnDescription = {
  id: "quantitySold",
  columnNameCandidates: ["Quantity Sold", "Sales"],
  description: (
    <FormattedMessage
      id="components/sales-data/sales-data-csv-columns:quantitySoldColumnDescription"
      defaultMessage="The number of servings of the product that have been sold in the sales period."
    />
  ),
};

export const productPriceColumnDescription: ColumnDescription = {
  id: "pricePerItem",
  columnNameCandidates: ["Product price", "Price Per Serving", "Unit Price"],
  description: (
    <FormattedMessage
      id="components/sales-data/sales-data-csv-columns:productPriceColumnDescription"
      defaultMessage="The price of the product serving <em>(Optional)</em>."
      values={{
        em: (chunks: React.ReactNode) => <em>{chunks}</em>,
      }}
    />
  ),
};

export const columnDescriptions: Array<ColumnDescription> = [
  productNameColumnDescription,
  productIdColumnDescription,
  productCodeColumnDescription,
  quantitySoldColumnDescription,
  productPriceColumnDescription,
];
